import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AdminGuard from "@/components/AdminGuard";
import AgeGate from "@/components/AgeGate";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import SocialProofToast from "@/components/SocialProofToast";
import AnalyticsPixels from "@/components/AnalyticsPixels";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import Account from "@/pages/Account";
import Track from "@/pages/Track";
import Wishlist from "@/pages/Wishlist";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import FlavourFinder from "@/pages/FlavourFinder";
import HealthTracker from "@/pages/health/HealthTracker";

function Chrome({ content, children }) {
  const loc = useLocation();
  const isPrivate = loc.pathname.startsWith("/health-tracker");
  if (isPrivate) return <>{children}</>;
  return (
    <>
      <AnalyticsPixels gaId={content?.ga_measurement_id} metaId={content?.meta_pixel_id} />
      <AgeGate />
      {content?.exit_intent_enabled !== false && <ExitIntentPopup />}
      {content?.social_proof_enabled !== false && <SocialProofToast />}
      <Navbar />
      <main className="min-h-[80vh]">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Chrome content={content}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Products />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/product" element={<Navigate to="/shop" replace />} />
            <Route path="/product/" element={<Navigate to="/shop" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            <Route path="/account" element={<Account />} />
            <Route path="/track" element={<Track />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/quiz" element={<FlavourFinder />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminGuard>
                  <AdminDashboard />
                </AdminGuard>
              }
            />
            <Route path="/health-tracker" element={<HealthTracker />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Chrome>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0d0d0d",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
